import { Injectable } from '@angular/core';
import { UturuncoUtils } from '../../utils/uturuncoUtils';
import { HttpClient } from '@angular/common/http';
import { DetalleCaja } from 'src/app/model/index.model';
import { BaseService } from './base.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DetalleCajaService extends BaseService<DetalleCaja> {

    constructor(protected override http: HttpClient) {
        super(http, 'detalleCaja');
    }


    getPreCierre() {
        this.other_header = UturuncoUtils.getHeader();
        let user = JSON.parse(UturuncoUtils.getSession("user"));
        let body = {
            "query":
                { "usuario": user.id }
        };
        return firstValueFrom(this.http
            .post(this.api + "/preCierreCaja/", body, { headers: this.other_header }));
    }
    getCierre(importe) {
        this.other_header = UturuncoUtils.getHeader();
        let user = JSON.parse(UturuncoUtils.getSession("user"));
        let body = {
            "query":
                { "usuario": user.id, "importe": importe },

        };
        return firstValueFrom(this.http
            .post(this.api + "/cierreCaja/", body, { headers: this.other_header }));
    }

    getDetaleCaja(id) {
        this.other_header = UturuncoUtils.getHeader();
        return firstValueFrom(this.http
            .get(this.api + "/getResumenVentas/" + id, { headers: this.other_header }));
    }
}
